import { styled } from "@mui/material";

export const Styled = {
    Container: styled("div")`
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        flex: 1;
        background: linear-gradient(
            to bottom left,
            ${props => props.theme.palette.primary.main},
            black,
            black
        );
    `,
};
